import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { SetupRP } from 'containers/forms/dashboard'
import { MaterialModal } from 'components/layout'
import getActivityClassName from 'helpers/dashboard/getActivityClassName'
import { ACTIVITY_SECTIONS } from 'constants/enums'

export default class SetupRPModal extends Component {
  static propTypes = {
    modalId: PropTypes.string,
  }

  render() {
    const { modalId } = this.props

    const colorClass = getActivityClassName(ACTIVITY_SECTIONS.residential_project.id)

    return (
      <MaterialModal.Body
        id={modalId}
        colorClass={colorClass}
        title='New Residential Project'
        titleKey='moduleTitle.new_residential_project'
      >
        <MaterialModal.Content>
          <SetupRP {...this.props} colorClass={colorClass} />
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}
